'use client';

import { createContext, useContext, useMemo } from 'react';
import { DEFAULT_PRICE_REGION, buildGeoPricingState, formatMoney } from '@/lib/geoPricing';

const GeoPricingContext = createContext(null);

/**
 * Client hook: detected country → price region (`price.json`), currency (`countries` + `currencies`).
 */
export function useGeoPricing() {
  const ctx = useContext(GeoPricingContext);
  const fallback = useMemo(() => {
    const b = buildGeoPricingState(DEFAULT_PRICE_REGION);
    return {
      ...b,
      formatPrice: (amount) => formatMoney(amount, b.currencyMeta.decimals),
    };
  }, []);

  return ctx || fallback;
}

export default function GeoPricingProvider({ initial, children }) {
  const value = useMemo(() => {
    const base = initial || buildGeoPricingState(DEFAULT_PRICE_REGION);
    const decimals = base.currencyMeta?.decimals ?? 2;
    return {
      ...base,
      formatPrice: (amount) => formatMoney(amount, decimals),
    };
  }, [initial]);

  return <GeoPricingContext.Provider value={value}>{children}</GeoPricingContext.Provider>;
}
